import { z } from "zod";

// Звёзды считает сервер: по времени, которое он же засёк, и по ошибкам,
// выведенным из присланного решения. Слову клиента тут ничего не верится.

export const starThresholdsSchema = z.object({
  /** До этого времени — три звезды */
  threeStarsMs: z.number().int().min(1000).default(60_000),
  /** До этого — две звезды, дальше одна */
  twoStarsMs: z.number().int().min(1000).default(150_000),
  /** Сколько ошибок допускает три звезды */
  threeStarsMistakes: z.number().int().min(0).default(0),
  /** Сколько ошибок допускает две звезды */
  twoStarsMistakes: z.number().int().min(0).default(3),
  /** Подсказка закрывает третью звезду */
  hintBlocksThird: z.boolean().default(true),
});

export type StarThresholds = z.infer<typeof starThresholdsSchema>;

export const defaultStarThresholds: StarThresholds = starThresholdsSchema.parse({});

export interface ScoreInput {
  durationMs: number;
  mistakes: number;
  hintsUsed: number;
  thresholds: StarThresholds;
  /** Базовая награда уровня в очках */
  basePoints: number;
}

export interface ScoreResult {
  stars: 1 | 2 | 3;
  points: number;
}

/** Множители очков за звёзды */
export const STAR_MULTIPLIER: Record<1 | 2 | 3, number> = { 1: 1, 2: 1.5, 3: 2 };

export function scoreAttempt(input: ScoreInput): ScoreResult {
  const { durationMs, mistakes, hintsUsed, thresholds, basePoints } = input;

  let stars: 1 | 2 | 3 = 1;
  if (durationMs <= thresholds.threeStarsMs && mistakes <= thresholds.threeStarsMistakes) stars = 3;
  else if (durationMs <= thresholds.twoStarsMs && mistakes <= thresholds.twoStarsMistakes) stars = 2;

  if (stars === 3 && thresholds.hintBlocksThird && hintsUsed > 0) stars = 2;

  return { stars, points: Math.round(basePoints * STAR_MULTIPLIER[stars]) };
}
